import { where } from 'firebase/firestore';

const DYNAMIC_DOMAIN_COLLECTION =
  /^domain_[a-z0-9_]+_(events|types|categories|actions|rules|queue|ruleFires)$/;

export function isDynamicDomainCollectionName(collectionName) {
  return typeof collectionName === 'string' &&
    DYNAMIC_DOMAIN_COLLECTION.test(collectionName);
}

/**
 * Firestore evaluates collection queries against their potential result set.
 * Dynamic Domain list rules therefore require both immutable identity fields
 * to be pinned. Equality-only identity clauses use Firestore's automatic
 * single-field index merging and do not require one composite index for every
 * generated collection id.
 */
export function dynamicDomainListConditions({
  collectionName,
  schoolId,
  domainId,
} = {}) {
  if (!isDynamicDomainCollectionName(collectionName)) return [];
  if (!schoolId || !domainId) {
    throw new Error(
      `Dynamic Domain collection ${collectionName} requires schoolId and domainId`,
    );
  }
  return [
    ['schoolId', '==', schoolId],
    ['domainId', '==', domainId],
  ];
}

export function dynamicDomainListConstraints(context) {
  return dynamicDomainListConditions(context).map(([field, operator, value]) => where(field, operator, value));
}
